export const awsName = "mrg:metworx:aws-name";
export const workflowDisplayName = "mrg:metworx:friendly-name";
export const blueprintId = "mrg:metworx:blueprint-id";
export const blueprintName = "mrg:metworx:blueprint-name";
export const userId = "mrg:metworx:user-id";
export const workflowOwner = "mrg:metworx:workflow-owner";
export const workflowUsername = "mrg:metworx:workflow:username";
export const createdBy = "mrg:metworx:created-by";
export const dnsName = "mrg:metworx:dns-name";
export const organizationId = "mrg:metworx:organization-id";
export const organizationName = "mrg:metworx:organization-name";
export const schedulerName = "mrg:metworx:scheduler-name";
export const gpu = "mrg:metworx:gpu";
export const templateName = "mrg:metworx:saved-configuration:name";
export const templateId = "mrg:metworx:saved-configuration:id";
